document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(() => {
    const el = document.querySelector('#trafficly-message');
    if (el && el.textContent.includes('in last 6 Hours')) {
      el.textContent = el.textContent.replace('in last 6 Hours', '').trim();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
